import {AbstractPricingItemSummaryMapper} from "../../abstract-pricing-item-summary.mapper";
import {PricingItemSummary} from "../../../../../../domain/out/pricing-item-summary";
import {DevicePricingItem} from "../../../../../../domain/in/quote/pricing-item/device-pricing-item";
import {PricingItem} from "../../../../../../domain/in/quote/pricing-item/pricing-item";
import {bigToString} from "../../../../../../utils/math-utils";
import {EnumShape} from "../../../../../../domain/enum/enum-shape";
import {Big} from "big.js";
import {MappingContext} from "../../mapping-context";

export class FrDiscoSolSynthesisMapper extends AbstractPricingItemSummaryMapper {

    protected async doMap(pricingItem: PricingItem, ctx: MappingContext): Promise<PricingItemSummary> {
        let devicePricingItem = pricingItem as DevicePricingItem;
        let pricingItemSummary = new PricingItemSummary();

        pricingItemSummary.codeElis = await ctx.resolveCodeElis(devicePricingItem.device.codeElis);
        pricingItemSummary.label = await this.getLabel(devicePricingItem, ctx);
        pricingItemSummary.quantity = devicePricingItem.userInputs.quantity;
        pricingItemSummary.appliedPrice = ctx.formatAmount(devicePricingItem.device.appliedPrice);
        pricingItemSummary.totalAppliedPrice = ctx.formatAmount(devicePricingItem.totalAppliedPrice);
        pricingItemSummary.frequency = await ctx.getFrequency(devicePricingItem);
        pricingItemSummary.initialStockSOL = this.getInitialStockSOL(devicePricingItem);
        pricingItemSummary.family = devicePricingItem.family;
        return pricingItemSummary;
    }


    async getLabel(devicePricingItem: DevicePricingItem, ctx: MappingContext) {
        const label = devicePricingItem.device.label;
        if (this.checkForRequiredCategoryAndSubFamily(devicePricingItem)) {
            const shapeValue = devicePricingItem.userInputs.shape;
            const translatedShapeValue = await ctx.translate('SHAPE_' + devicePricingItem.userInputs.shape);
            const shapeLabel = ' /' + await ctx.translate('LABEL_SHAPE') + ': ';
            const unitLabel = ' m';
            if (shapeValue === EnumShape.CIRCLE || shapeValue === EnumShape.SEMICIRCLE) {
                const diameterLabel = ' /' + await ctx.translate('LABEL_DIAMETER_SIMPLIFIED') + ': ';
                return devicePricingItem.device.label + shapeLabel + translatedShapeValue + diameterLabel + devicePricingItem.userInputs.diameter + unitLabel;
            } else {
                const heightLabel = ' /' + await ctx.translate('LABEL_HEIGHT_SIMPLIFIED') + ': ';
                const widthLabel = ' /' + await ctx.translate('LABEL_WIDTH_SIMPLIFIED') + ': ';
                return devicePricingItem.device.label + shapeLabel + translatedShapeValue + widthLabel + devicePricingItem.userInputs.width + unitLabel + heightLabel + devicePricingItem.userInputs.height + unitLabel;
            }
        }
        return label;
    }

    getInitialStockSOL(devicePricingItem: DevicePricingItem) {
        if (devicePricingItem.family === 'Tapis Personnalisé') {
            return bigToString(new Big('2').mul(devicePricingItem.userInputs.quantity), 0);
        } else {
            return '';
        }
    }

    checkForRequiredCategoryAndSubFamily(devicePricingItem: DevicePricingItem): boolean {
        let family = devicePricingItem.family;
        let subFamily = devicePricingItem.device.articleDetails?.subFamily;
        return family === 'Tapis Personnalisé' && subFamily === 'Dimension spécifique';
    }

}
